"use client";

import { useCallback } from "react";
import {
	HmcButton,
	HmcCard,
	HmcContainerHeader,
	HmcIcon,
} from "@adi-ctx/harmonic-core-components-react";
import { t } from "@/utils";
import { useAuth } from "@/components";
import { RiLogoutBoxRLine } from "@remixicon/react";

/**
 * Logout UI component for the CMS
 */
export default function Logout() {
	const {
		cognitoFullLogout,
		cognitoPartialLogout,
		isAuthenticated,
		isAuthenticatingInProgress,
	} = useAuth();

	const partialLogout = useCallback(() => {
		cognitoPartialLogout();
	}, [cognitoPartialLogout]);

	if (isAuthenticatingInProgress || !isAuthenticated) {
		return;
	}

	return (
		<div className="mx-auto w-full bg-[var(--hmc-color-gray-100)] p-4 sm:w-[640px] sm:py-10">
			<HmcCard data-testid="cms-logout">
				<HmcContainerHeader
					slot="card-header"
					heading={t("logout.title")}
					data-testid="cms-logout-header"
					className="flex items-center"
				>
					{t("logout.title")}
					<RiLogoutBoxRLine
						size={30}
						className="-mt-1"
						data-testid="cms-logout-icon"
						// @ts-expect-error "slot" doesn't exist on this component
						slot="icon"
					/>
				</HmcContainerHeader>

				<HmcButton
					isIconOnly
					slot="card-header-actions"
					data-testid="cms-logout-close-icon"
					size="sm"
					kind="ghost"
					onClick={() => {
						history.go(-1);
					}}
				>
					<HmcIcon name="close-m" />
				</HmcButton>

				<div className="hmc-body-s">
					<div className="hmc-body-s">
						<p className="mb-4 font-bold" data-testid="cms-logout-subtitle">
							{t("logout.subtitle")}
						</p>
						<p data-testid="cms-logout-desc">{t("logout.desc")}</p>
					</div>
				</div>

				<div slot="card-footer" className="flex justify-end gap-3">
					<HmcButton
						kind="tertiary"
						size="sm"
						data-testid="cms-logout-cancel-button"
						onClick={() => {
							history.go(-1);
						}}
					>
						{t("logout.cancel")}
					</HmcButton>

					<HmcButton
						size="sm"
						kind="secondary"
						data-testid="cms-logout-full-button"
						onClick={cognitoFullLogout}
					>
						{t("logout.fullLogoutButton")}
					</HmcButton>

					<HmcButton
						size="sm"
						kind="primary"
						data-testid="cms-logout-partial-button"
						onClick={partialLogout}
					>
						{t("logout.partialLogoutButton")}
					</HmcButton>
				</div>
			</HmcCard>
		</div>
	);
}
